import { useState } from 'react'
import {
  useActivateProjectUserMutation,
  useDeactivateProjectUserMutation,
} from 'apiv2'
import { notifyError } from 'ui/components/Notify'

export const useProjectUserStatus = ({ slug }) => {
  const [changingUserId, setChangingUserId] = useState(null)

  const [activateProjectUserMutation] = useActivateProjectUserMutation()
  const [deactivateProjectUserMutation] = useDeactivateProjectUserMutation()

  const handleDeactivateProjectUser = async (userId) => {
    setChangingUserId(userId)

    try {
      await deactivateProjectUserMutation({
        slug,
        userId,
      }).unwrap()
    } catch (error) {
      notifyError(error?.data?.message || 'Ошибка деактивации пользователя')
    } finally {
      setChangingUserId(null)
    }
  }

  const handleActivateProjectUser = async (userId) => {
    try {
      setChangingUserId(userId)

      await activateProjectUserMutation({ slug, userId }).unwrap()
    } catch (error) {
      notifyError(error?.data?.message || 'Ошибка активации пользователя')
    } finally {
      setChangingUserId(null)
    }
  }

  return {
    changingUserId,
    handleDeactivateProjectUser,
    handleActivateProjectUser,
  }
}
